module.exports = __webpack_public_path__ + "img/next.b3f709d5.svg";